import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import type { LabelValuePair, LabelValueStringPair } from 'Types/common'

import { beListApiGetListOfNlList } from 'Api/beListApiTS'

import { beAccountSettingsApiGetMobilePrefixes } from 'Api/beAccountSettingsApi'

export const fetchLists = async (): Promise<LabelValuePair[]> => {
  const { Items } = await beListApiGetListOfNlList({})

  return Items.map((l) => ({
    value: l.IdList,
    label: `${l.IdList} - ${l.Name}`,
  }))
}

export const getCurrentList = (): number => {
  const idList: number = storeGet(STORE_KEY_ID_LIST)

  return idList
}

export const fetchMobilePrefixes = async (): Promise<
  LabelValueStringPair[]
> => {
  const { Items } = await beAccountSettingsApiGetMobilePrefixes()
  return Items.sort((a, b) => a.Code.localeCompare(b.Code)).map((cc) => ({
    label: `00${cc.Code} - ${cc.Description}`,
    value: `00${cc.Code}`,
  }))
}
